angular.module('ib-box-module-link-module', []);